import axiosInstance from './axiosInstance';

const branchService = {
  getBranches: () => {
    return axiosInstance.get('/branches');
  },
  addBranch: (branchData) => {
    return axiosInstance.post('/branches', branchData);
  },
  deleteBranch: (id) => {
    return axiosInstance.delete(`/branches/${id}`);
  },
  updateBranch: (id, branchData) => {
    return axiosInstance.put(`/branches/${id}`, branchData);
  },
};

export default branchService;
